require('prismjs/themes/prism-okaidia.css')
exports.onClientEntry = () => {}
